require([
    "appConfig",
    "angular",
    //"angular-animate",
    "ViewUtilities/WindowHelper",
    "ProductLibrary/productLibraryWorkspaceAppConfig",
    "angular-ui-router",
    "ViewUtilities/AutoSizeHeight",
    "ViewUtilities/FontComponent",
    "ViewUtilities/ColorPicker",
    "DataGrid/GridRowDoubleClick",
    "ViewUtilities/CustomOnChangeDirective",
    "ViewUtilities/ComboSearch",
    "ViewUtilities/matchTextHeight",
], function (config, angularLib, 
//ngAnimateLib,
windowHelper, rootAppConfig) {
    rootAppConfig.config();
    windowHelper.initialize();
    angularLib.bootstrap(document, ["appModule"]);
    console.debug("All js modules loaded.");
});
//# sourceMappingURL=productLibraryWorkspace.main.js.map